
import { Inject } from "vue-property-decorator"
import { Options, Vue } from "vue-class-component"
import Colorpicker from "./colorpicker"
import { uuid } from "@/utils/obj"
@Options({
  name: "field",
  props: ["item"]
})
export default class Field extends Vue {
  @Inject() config!: any
  readonly item: any
  textbox: string[] = []
  items: any[] = []
  colorPickerId?: string
  colorPickerLeft: string | null = null

  created() {
    if (this.item.field === "textbox") {
      this.textbox = [...this.item.get(this.config.setup.element)]
    } else if (this.item.field === "grid-item") {
      this.items = [...this.item.get(this.config.setup.element)]
    } else if (this.item.field === "color") {
      const self: any = this
      this.colorPickerId = "color-picker-" + uuid()
      this.$nextTick(() => {
        const picker = new Colorpicker({
          el: this.colorPickerId,
          color: self.item.get(self.config.setup.element),
          change: function(elem: any, hex: string) {
            elem.style.backgroundColor = hex
            self.item?.callback(self.config.setup.element, hex)
          }
        })
      })
    }
  }

  onTextboxKeydown(evt: any, item: any) {
    const textbox = this.textbox
    const target = evt.target
    // 删除
    if (evt.key === "Backspace" && target.value === "") {
      textbox.splice(textbox.length - 1, 1)
      item.callback(this.config.setup.element, this.textbox)
    }
    // 回车
    else if (evt.key === "Enter" && target.value.trim() !== "") {
      textbox.splice(textbox.length, 0, target.value.trim())
      item.callback(this.config.setup.element, this.textbox)
      target.value = ""
    }
  }

  onGridItemAdd() {
    this.items.splice(this.items.length, 1, { span: 12, children: [] })
    this.item.callback(this.config.setup.element, this.items)
  }

  onGridItemDel(index: number) {
    // 保留一个
    if (this.items?.length > 1) {
      this.items.splice(index, 1)
      this.item.callback(this.config.setup.element, this.items)
    }
  }

  onGridItemKeyup(evt: any, index: number) {
    const element = this.items[index]
    const value = evt.target.value
    element.span = Number(value)
    this.item.callback(this.config.setup.element, this.items)
  }

  // onColorClick(evt: any) {
  //   const maxWidth: number = document.body.offsetWidth
  //   const { offsetLeft } = this.config.el
  //   const left: number = evt.target.offsetLeft
  //   let ox = maxWidth > offsetLeft + left + 425 ? 0 : maxWidth - (offsetLeft + left + 425)
  //   console.log(ox)
  //   if (this.colorPickerLeft === null) {
  //     this.colorPickerLeft = ox + "px"
  //   }
  //   evt.returnValue = false
  //   // evt.stopPropagation()
  // }
}
